// extracted by mini-css-extract-plugin
export default {"nav_item":"NavItem_nav_item__aX+IQ","active":"NavItem_active__+tNJM","btn":"NavItem_btn__ARLJt"};